module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-182.2f58b3d.woff2";